import { mediaQueryStyles, typographyStyles } from "@newsela/angelou";

const { mediaQuery: breakpoint } = mediaQueryStyles;
const { textMObj, fontSize } = typographyStyles;

export const actionsContainerCss = {
  marginTop: 16,
  width: "100%",
  display: "flex",
  flexDirection: "column",
  gap: 16,
  [breakpoint.downTo("sm")]: {
    width: "auto",
    flexDirection: "row",
    marginTop: "auto",
    button: {
      height: 48,
      padding: 16,
    },
  },
};

export const pageDescriptionCss = {
  ...textMObj,
  display: "flex",
  width: "100%",
  flexDirection: "column",
  alignItems: "flex-end",
  alignSelf: "flex-end",
  "> * + *": {
    marginTop: 4,
  },
  [breakpoint.downTo("sm")]: {
    width: "auto",
  },
};

export const bannerForRelayingStudentSearchBlockCss = {
  body: {
    "&&": {
      ...fontSize.textM,
    },
  },
  innerContentContainer: {
    display: "flex",
    alignItems: "center",
    ...fontSize.textM,
  },
};

export const buttonContentAlignmentCSS = {
  root: {
    justifyContent: "center",
  },
};

export const lastSyncTextWidth = {
  [breakpoint.upTo("sm")]: {
    width: "100%",
  },
};

export const classSyncLoadingSpinner = {
  root: {
    margin: 0,
  },
};
